import { GroupedPermission } from "../types/permissions";
import { useApiRequest } from "./axios";
import axios from "./axios";
import { useCallback } from "react";

export const PERMISSION_GROUPS_URL = '/users/permission-groups/';
export const GROUPED_PERMISSIONS_URL = '/users/grouped-permissions/';

export const useGroupedPermissions = () => {
  const { loading, error, executeRequest } = useApiRequest();

  const query = useCallback(async (): Promise<GroupedPermission[] | undefined> => {
    const { data } = await executeRequest(() => axios.get(GROUPED_PERMISSIONS_URL));
    return data;
  }, [executeRequest]);

  return { loading, error, query };
};
